/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface DeleteSupplierException$Params {
  supplierId: string;
  exclusionFromDate: string;
}

export function deleteSupplierException(
  http: HttpClient,
  rootUrl: string,
  params: DeleteSupplierException$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<{}>> {
  const rb = new RequestBuilder(rootUrl, deleteSupplierException.PATH, 'delete');
  if (params) {
    rb.path('supplierId', params.supplierId, {});
    rb.path('exclusionFromDate', params.exclusionFromDate, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{}>;
    }),
  );
}

deleteSupplierException.PATH = '/service/v1/supplierExceptions/{supplierId}/{exclusionFromDate}';
